import PriceSection from "components/Service/PriceSection";
import HeroTraining from "components/Training/HeroTraining";
import ListTraining from "components/Training/ListTraining";
import QuoteTraining from "components/Training/QuoteTraining";
import MissionTraining from "components/TrainingBusiness/MissionTraining";
import React from "react";

const Training = () => {
  return (
    <div>
      <HeroTraining />
      <QuoteTraining />
      <MissionTraining />
      <ListTraining />
      <PriceSection />
    </div>
  );
};

export default Training;
